import {
  IgrDataGrid,
  IgrDataGridModule,
  IgrNumericColumn,
  IgrTextColumn,
} from "igniteui-react-grids";
import React from "react";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import { getNoTime, getRank, getStartTime } from "../API";
import dayjs from "dayjs";
import { makeTime } from "./Rank";
import { entryList } from "../entryList";

IgrDataGridModule.register();

export function CpRank() {
  const [selectedValue, setSelectedValue] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState<any[]>([]);
  const [options, setOptions] = React.useState<any[]>([]);

  const handleChange = async (e: any) => {
    setLoading(true);

    const cp = e.target.value;
    setSelectedValue(cp);
    const [resGetRank, resGetNoTime, resGetStartTime] = await Promise.all([
      axios.get(getRank),
      axios.get(getNoTime),
      axios.get(getStartTime),
    ]);
    if (!resGetRank.data.totalRank) {
      setLoading(false);
      return;
    }
    const startTime = dayjs(resGetStartTime.data.startTime);
    setData(
      resGetRank.data[cp].map((no: number, index: number) => {
        const time = dayjs(
          resGetNoTime.data[no].find((e: any) => e.cp === cp).time
        );
        const second = time.diff(startTime, "seconds");
        const targetNo = entryList.find((entry) => entry.No === no);
        return {
          rank: index + 1,
          no,
          time: makeTime(second),
          name: targetNo?.Name,
        };
      })
    );
    setLoading(false);
  };

  React.useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const resGetRank = await axios.get(getRank);
      const cps: any[] = [""];
      for (const key in resGetRank.data) {
        if (key !== "totalRank") {
          cps.push(key);
        }
      }
      setOptions(cps);
      setLoading(false);
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  }

  return (
    <>
      <div style={{ margin: 10 }}>
        <select value={selectedValue} onChange={handleChange}>
          {options.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
      {selectedValue ? (
        data.length ? (
          <div
            style={{
              padding: "20px 50px 20px 50px",
              overflow: "scroll",
              WebkitOverflowScrolling: "touch",
              pointerEvents: "none",
            }}
          >
            <IgrDataGrid
              height="calc(100% + 1px)"
              width="100%"
              dataSource={data}
              autoGenerateColumns={false}
            >
              <IgrNumericColumn field="rank" width="90" headerText="順位" />
              <IgrNumericColumn field="no" width="90" headerText="No" />
              <IgrTextColumn field="name" headerText="名前" />
              <IgrTextColumn field="time" headerText="通過タイム" />
            </IgrDataGrid>
          </div>
        ) : (
          <>このCPを通過した選手はいません</>
        )
      ) : null}
    </>
  );
}
